import React, { useEffect, useState } from "react";

/* Gradient defs need ids unique per mounted ring — React 16 has no useId. */
let ringSeq = 0;

/*
 * Animated SVG progress ring (0–100). Pure CSS/SVG — the dashoffset
 * transition in app.css animates it; reduced-motion users see it instantly.
 */
export default function ProgressRing({
    value = 0,
    size = 64,
    stroke = 6,
    className = "",
    color,
}) {
    const clamped = Math.max(0, Math.min(100, Number(value) || 0));
    const radius = (size - stroke) / 2;
    const circumference = 2 * Math.PI * radius;
    const [display, setDisplay] = useState(0);
    const [gradientId] = useState(() => `ring-grad-${++ringSeq}`);

    useEffect(() => {
        // Next frame so the dashoffset transition actually runs on mount.
        const id = requestAnimationFrame(() => setDisplay(clamped));
        return () => cancelAnimationFrame(id);
    }, [clamped]);

    return (
        <svg
            className={`ring-svg ${className}`}
            width={size}
            height={size}
            viewBox={`0 0 ${size} ${size}`}
            role="img"
            aria-label={`${Math.round(clamped)} percent`}
        >
            <defs>
                {/* Deep brand → bright brand across the sweep, so the arc
                    gains depth instead of reading as one flat stroke. */}
                {/* stop-color goes through `style` — var() is not resolved
                    when it sits in an SVG presentation attribute. */}
                <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" style={{ stopColor: "var(--brand)" }} />
                    <stop offset="100%" style={{ stopColor: "var(--brand-accent)" }} />
                </linearGradient>
            </defs>
            <circle
                className="ring-track"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                strokeWidth={stroke}
            />
            <circle
                className="ring-value"
                cx={size / 2}
                cy={size / 2}
                r={radius}
                fill="none"
                strokeWidth={stroke}
                strokeDasharray={circumference}
                strokeDashoffset={circumference * (1 - display / 100)}
                style={{ stroke: color || `url(#${gradientId})` }}
            />
        </svg>
    );
}
